<template>
  <div class="va-page-not-found justify--center position-relative pb-5">
    <div class="va-page-not-found__inner align--center">
      <slot name="image"/>
      <div class="va-page-not-found__title text--center mb-4">
        <div v-if="this.$session.get('IberoJWTAdmin').name != ''">
            {{this.$session.get('IberoJWTAdmin').name}}
        </div>
        <div v-else>
            Administrador Ibero
        </div>
      </div>
      <div class="va-page-not-found__text px-4 text--center">
        <span src="" v-if="this.$session.get('IberoJWTAdmin').unique_name.indexOf('ibero.edu.co') >= 1">
          <img src="./../../../assets/icons/loading-cargando.gif" class="gift">
        </span>
        <span v-else>
          Su usuario "{{this.$session.get('IberoJWTAdmin').unique_name}}" no es un correo valido, recuerde que para ingresar al Portal Administrativo requiere hacerlo con el correo "ibero.edu.co".
        </span>
      </div>
      <slot/>
      <a @click="sendLogout">
        <button type="submit" class="loginbtn primaryBtn">Cerrar Sesión</button>
      </a>

    </div>
    <made-by-component/>
    <div class="va-page-not-found__wallpaper"/>
  </div>
</template>

<script>
import MadeByComponent from './MadeByComponent'
import authentication from '@/store/authentication'

export default {
  name: 'va-page-not-found',
  components: {
    MadeByComponent,
  },
  methods: {
    sendLogout () {
      this.$session.destroy()
      this.$store.state.configAuth.redirectUri = this.$store.state.configAuth.redirectUriLogout
      authentication.initialize(this.$store.state.configAuth).then(_ => { }).catch(e => console.log(e))
      authentication.signOut()
    },
  },
  props: { withoutButton: Boolean },
}
</script>

<style lang="scss">
  .va-page-not-found {
    min-height: 100vh;
    background-color: #fff;
    display: flex;
    padding-top: 12%;
    @include media-breakpoint-down(sm) {
      padding-top: 8%;
    }
    &__inner {
      display: flex;
      flex-direction: column;
      .va-icon-vuestic {
        width: 19rem;
        height: 2rem;
        margin-bottom: 13%;
      }
    }
    &__title {
      color: #222;
      font-size: 3rem;
      line-height: 1.25em;
      font-weight: 500;
      @include media-breakpoint-down(xs) {
        font-size: 1.5rem;
      }
    }
    &__text {
      margin-bottom: 2.5rem;
      color: #222;
    }
    &__wallpaper {
      position: absolute;
      bottom: 0;
      left: 1rem;
      width: 20%;
      height: 30%;
      background-color: transparent;
      background-image: url("../../../assets/images/PCIcon.png");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: bottom center;
      @include media-breakpoint-down(xs) {
        display: none;
      }
    }
  }

  .gift
  {
    width: 100px;
  }

  .loginbtn primaryBtn{
    background-color: #fff;
    width: 200px;
    padding: 10px;
  }

  .va-page-not-found__text
  {
    font-size: 16px;
  }
</style>
